import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { ROUTES } from '../constants';
import '../style.scss';
import quizpic from '../images/quiz.png';
import generatetrippic from '../images/generate-trip.png';
import modifytrippic from '../images/modify-trip.png';
import ontrippic from '../images/on-trip.png';

function About() {
  const navigate = useNavigate();
  const [showFixedHeader, setShowFixedHeader] = useState(false);
  const [opacity, setOpacity] = useState(0);
  const phrases = ['Book tickets', 'Reserve hotels', 'Find attractions', 'Arrange transportation',
    'Find dining options', 'Check weather conditions', 'Overcome language barriers', 'Manage time',
    'Set and stick to a budget', 'Account for local events', 'Ensure safety and health', 'Pack appropriately',
    'Handle currency exchange', 'Book activities in advance', 'Organize travel documents'];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  // speed of typing effect
  const typingSpeed = 150; // Speed for typing in milliseconds
  const deletingSpeed = 50; // Speed for deleting in milliseconds
  const delay = 1000; // Delay before starting to delete or move to the next word

  // check scroll for fixed header
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const docHeight = document.documentElement.scrollHeight;
      // calculate scroll progress as a percentage
      const scrollPercentage = (scrollTop / docHeight) * 100;
      console.log('Scroll Progress:', scrollPercentage); // debug
      if (scrollPercentage > 73) {
        setShowFixedHeader(true);
      } else {
        setShowFixedHeader(false);
      }
      // calculate opacity based on scroll progress
      const newOpacity = Math.min((scrollPercentage - 73) / 10, 1); // can play with this: how fast to fade
      setOpacity(newOpacity);
      console.log('Opacity:', newOpacity); // debug
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  // typing effect for problem statement
  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];
    // control typing/deleting speed
    const timeout = setTimeout(() => {
      if (isDeleting) {
        // Deleting
        setText((prev) => prev.slice(0, -1));
        if (text === '') {
          // Switch to the next phrase after deleting
          setIsDeleting(false);
          setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % phrases.length);
        }
      } else {
        // type
        setText((prev) => currentPhrase.slice(0, prev.length + 1));
        if (text === currentPhrase) {
          // pause before deleting
          setTimeout(() => setIsDeleting(true), delay);
        }
      }
    }, isDeleting ? deletingSpeed : typingSpeed);
    // cleanup
    return () => clearTimeout(timeout);
  }, [text, isDeleting, currentPhraseIndex, phrases]);

  const getUserProfile = (tokenInfo) => {
    axios.get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${tokenInfo?.access_token}`, {
      headers: {
        Authorization: `Bearer ${tokenInfo?.access_token}`,
        Accept: 'Application/json',
      },
    }).then((resp) => {
      console.log(resp);
      localStorage.setItem('user', JSON.stringify(resp.data));
    }).catch((error) => {
      console.error('Failed to fetch user profile:', error);
    });
  };

  const handleLogin = useGoogleLogin({
    onSuccess: (codeResp) => {
      getUserProfile(codeResp);
      navigate(ROUTES.MY_TRIPS);
    },
    onError: (error) => console.log(error),
  });

  return (
    <>
      {/* conditional fixed header */}
      {showFixedHeader && (
        <div className="fixed-header">
          <div className="fixed-header-content" style={{ opacity }}>
            <div className="fixed-header-text">
              <h1>XING</h1>
              <p>Your Personal Trip Planner and Travel Curator</p>
            </div>
            <button className="login-button" onClick={handleLogin}>Get Started</button>
          </div>
        </div>
      )}

      {/* hero page */}
      <div className="about-page">
        <div className="content-container">
          <h1>XING</h1>
          <p>Your Personal Trip Planner and Travel Curator</p>
          <button className="login-button" onClick={handleLogin}>Get Started</button>
        </div>
      </div>

      {/* problem */}
      <div className="problem-content">
        <h2>Travel Planning is Overwhelming: </h2>
        <div className="dynamic-text-content">
          <h3>{text}</h3>
        </div>
      </div>

      {/* solution */}
      <div className="solution-content">
        <h2>But travel is supposed to be fun! Isn&apos;t it?<br />At least this is what we believe at</h2>
        <h1>XING</h1>

        {/* steps */}
        <div className="steps-container">
          {/* step 1 */}
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Step 1: Fill out a simple questionnaire</h3>
              <p>Enter your basic trip preferences, including destination, duration, and travel companions.</p>
              <img src={quizpic} alt="Step 1" className="step-image" />
            </div>
          </div>

          {/* step 2 */}
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Step 2: Generate Trip</h3>
              <p>Our app generates a personalized itinerary for your trip, tailored to your preferences.</p>
              <img src={generatetrippic} alt="Step 2" className="step-image" />
            </div>
          </div>

          {/* step 3 */}
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Step 3: Personalize it More</h3>
              <p>Customize your itinerary further by adding or removing activities, adjusting timing, and more.</p>
              <img src={modifytrippic} alt="Step 3" className="step-image" />
            </div>
          </div>

          {/* step 4 */}
          <div className="step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Step 4: Enjoy Your Trip</h3>
              <p>Get ready to embark on your well-planned journey with confidence and ease.</p>
              <img src={ontrippic} alt="Step 4" className="step-image" />
            </div>
          </div>

          {/* login */}
          <div className="step">
            <button className="login-button" onClick={handleLogin}>Get Started</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
